import Vue from 'vue';
import VueI18n from 'vue-i18n';
import router from './routers/index';
import messages from './i18n/index';
import { setCookie, FOUR_MINS } from '@seller/gilgamesh-web-http-client';
import CustomValidator from './plugins/customValidator';
import ValidatorTr from 'vee-validate/dist/locale/tr';
import VeeValidate, { Validator } from 'vee-validate';
import App from './App.vue';
import store from '@/stores/index';
import filters from './filters/index';
import Readonly from './directives/Readonly';
import mobile from './utils/mobile';
import VueGtm from 'vue-gtm';
import SmoothPicker from 'vue-smooth-picker';

const isProd = process.env.VUE_APP_NODE_ENV === 'production';

Vue.config.productionTip = false;

Vue.use(VueGtm, {
  id: 'GTM-TD35NT8',
  enabled: true,
  debug: !isProd,
});

Vue.use(VueI18n);
Vue.use(filters);
Vue.use(SmoothPicker);

Vue.use(VeeValidate, {});
Validator.localize('tr', ValidatorTr);
Vue.use(CustomValidator, Validator);

Vue.directive('readonly', Readonly);

const locale = 'tr';

const i18n = new VueI18n({
  locale,
  messages,
});

new Vue({
  router,
  i18n,
  store,
  data () {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      cdnUrl: process.env.VUE_APP_CDN_URL,
      basePath: process.env.VUE_APP_BASE_PATH,
      tyUrl: process.env.VUE_APP_TY_URL,
      permissions: {
        camera: false,
      },
    };
  },
  methods: {
    trackEvent (event) {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      event.event = 'GAEvent';
      event.eventName = 'AppCatalog';
      window.dataLayer.push(event);
      mobile.pushGAEvent(event);
    },
  },
  created () {
    const token = this.$route.query.token;
    const accessToken = this.$route.query.accessToken;
    const refreshToken = this.$route.query.refreshToken;
    const version = this.$route.query.version;

    if (token) {
      setCookie('mobile_auth_token', token);
    }

    if (accessToken) {
      setCookie('mobile_access_token', accessToken, FOUR_MINS);
    }

    if (refreshToken) {
      setCookie('mobile_refresh_token', refreshToken);
    }

    if (version) {
      setCookie('mobile_version', version);
    }
    const messageListener = (e) => {
      try {
        const data = JSON.parse(e.data);
        this.permissions.camera = data.cameraPermission === 'granted';
      } catch {}
    };
    window.addEventListener('message', messageListener);
    document.addEventListener('message', messageListener);

    // filter.clear();
  },
  render: h => h(App),
}).$mount('#app');
